import React, { useState } from 'react';
import illustration from '../../../../../images/survey/survey-2-illustration.svg';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import RightArrow from '../../../../Icons/icons/RightArrow';
import { useSurveyContext } from './surveyContext';
import { surveyForm2Validation } from '../../../../../utils/validationSchema';
import { updateStorageObject } from '../../../../../utils/global';
import { useFormValidation } from '../../../../../hooks/useFormValidation';
import { Mixpanel } from '../../../../../utils/mixpanel';

const SurveyPage2 = () => {
  const { setSurveyFormStep, form2Data, setForm2Data } = useSurveyContext();

  const { errors, setErrors, validate } = useFormValidation(surveyForm2Validation);

  const onFormSubmit = async (e) => {
    e?.preventDefault();
    const isValid = validate(form2Data);
    if (!isValid) return;
    Mixpanel.track('onboarding_step_completed', { 'Step Name': 'Second Step', 'Step Number': 2, Responses: form2Data });
    updateStorageObject('onboarding-form-data', 'form2', form2Data);
    setSurveyFormStep(3);
  };

  return (
    <form onSubmit={onFormSubmit}>
      <div className="survey-2-container">
        <div className="survey-2-content">
          <div className="survey-2-form">
            <div className="survey-2-textarea-container">
              <div className="survey-2-form-text-area-label">
                🤔 Describe your ideal outcome assuming this works for you.
              </div>
              <textarea
                value={form2Data.whySaral}
                onChange={(e) => {
                  setErrors((e) => ({ ...e, whySaral: null }));
                  setForm2Data((p) => ({ ...p, whySaral: e.target.value }));
                }}
                rows={6}
                className="survey-2-form-text-area"
                placeholder="What is your desired transformation? What are you looking to achieve?"
              />
              {errors.whySaral && <div className="survey-error-text">{errors.whySaral}</div>}
            </div>
            <div className="survey-2-textarea-container">
              <div className="survey-2-form-text-area-label">😊 How did you hear about us?</div>
              <textarea
                value={form2Data.saralReferal}
                onChange={(e) => {
                  setErrors((e) => ({ ...e, saralReferal: null }));
                  setForm2Data((p) => ({ ...p, saralReferal: e.target.value }));
                }}
                draggable={false}
                rows={6}
                className="survey-2-form-text-area"
                placeholder="Do you remember when you first hear about SARAL and why you decided to start now?"
              />
              {errors.saralReferal && <div className="survey-error-text">{errors.saralReferal}</div>}
            </div>
            <div className="survey-2-bottom-container">
              <ButtonComponent
                onClick={() => setSurveyFormStep(1)}
                style={{ flex: 1 }}
                variant="secondary"
              >
                Back
              </ButtonComponent>
              <ButtonComponent
                style={{ flex: 2 }}
                type="submit"
              >
                Customize My Experience <RightArrow color="#fff" />
              </ButtonComponent>
            </div>
          </div>
          <div className="survey-2-illustration">
            <img src={illustration} alt="illustration" />
          </div>
        </div>
        <div className="survey-1-bottom-container"></div>
      </div>
    </form>
  );
};

export default SurveyPage2;
